import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { clearFix } from 'polished';
import { withRouter } from 'react-router-dom';

import breakpoints from '../styles/breakpoints';

import Price from '../components/Price';
import Link from '../components/Link';

import { arrowIcon } from '../media/icons';

import {
  WideButton,
  DarkWideButton,
  HollowButton
} from '../components/Buttons';

import { scrollTo } from '../utils/window';

export const Wrapper = styled.div`
  margin: 0 auto;
  max-width: ${p => p.theme.globalWidthSmall};
`;

export const Row = styled.div`
  margin-left: -${p => p.theme.gutterSmall};
  margin-right: -${p => p.theme.gutterSmall};
  ${clearFix()}
`;

const Column = styled.div`
  width: 100%;
  margin-bottom: 25px;

  ${breakpoints.large`
    width: calc(50% - 5px);
    ${p => p.fullWidth && css`
      width: 100%;
    `}
  `}
  &:nth-child(odd) {
    float: left;
  }
  &:nth-child(even) {
    float: right;
  }
`;

const ContentColumn = styled.div`
  text-align: center;
  margin-bottom: 20px;
  width: 100%;
  ${breakpoints.medium`
    width: calc(50% - 5px);
    text-align: right;
    &:first-child {
      text-align: left;
    }
    ${p => p.fullWidth && css`
      width: 100%;
    `}
  `}
  &:nth-child(odd) {
    float: left;
  }
  &:nth-child(even) {
    float: right;
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

const Content = styled.div`
  padding: 30px 40px;
  background-color: ${p => p.theme.colors.lightBg};
`;

const SendRequest = styled(Link)`
  color: ${p => p.theme.colors.lightFont};
  display: block;
  margin-top: 10px;

  &:hover {
    color: ${p => p.theme.colors.darkFont};
    text-decoration: none;
  }
`;

const CalloutButton = styled.button`
  background-color: ${p => p.theme.colors.primary};
  color: white;
  position: fixed;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  z-index: 9999;
  width: 45px;
  height: 45PX;
  padding-bottom: 10px;
  right: 12px;
  bottom: 12px;
  font-size: 80%;
  ${breakpoints.large`
    font-size: 100%;
    bottom: 45px;
    right: 45px;
    width: 80px;
    height: 80px;
    padding-bottom: 12px;
  `};
`;

const CalloutButtonIcon = styled.img`
  width: 12px;
  position: absolute;
  bottom: 8px;
  left: calc(50% - 6px);
  ${breakpoints.large`
    bottom: 20px;
  `};
`;

function AddToCart({
  isInCart,
  carPartId,
  stockNumber,
  carPartName,
  price,
  shipping,
  newPrice,
  history,
  addUsedToCart = () => { },
  addNewToCart = () => { }
}) {
  return (
    <Wrapper>
      <Row id="buy-row">
        {(!(price && price > 0) || !(shipping && shipping > 0)) && <Column
          fullWidth={!(newPrice && newPrice > 0)}
        >
          <h3>Kjøp bruktdel</h3>
          <Content>
            <Row>
              <ContentColumn>
              </ContentColumn>
              <ContentColumn>
                <DarkWideButton
                  onClick={(e) => {
                    e.preventDefault();

                    history.push(`/foresporsel/?id=${carPartId}&lagernummer=${stockNumber}&delenavn=${carPartName}`);
                  }}
                >
                  Send forespørsel »
                </DarkWideButton>
              </ContentColumn>
            </Row>
          </Content>
        </Column>}
        {(price && price > 0 && shipping && shipping > 0) ? (
          <Column
            fullWidth={!(newPrice && newPrice > 0)}
          >
            <h3>Kjøp bruktdel</h3>
            <Content>
              <Row>
                <ContentColumn>
                  {price && <Price amount={price} shipping={shipping} /> || ''}
                </ContentColumn>
                <ContentColumn>
                  {isInCart && (
                    <Link to="/handlekurv/">
                      <HollowButton>Se i handlekurv</HollowButton>
                    </Link>
                  )}

                  {!isInCart && (
                    <WideButton onClick={addUsedToCart}>Kjøp</WideButton>
                  )}

                  <SendRequest
                    to={`/foresporsel/?id=${carPartId}&lagernummer=${stockNumber}&delenavn=${carPartName}`}
                  >
                    Send forespørsel »
                  </SendRequest>
                </ContentColumn>
              </Row>
            </Content>
          </Column>
        ) : null}

        {newPrice && newPrice > 0 ? (
          <Column
            fullWidth={true}
          >
            <h3>Kjøp nydel</h3>
            <Content>
              <Row>
                <ContentColumn>
                  <Price dark amount={newPrice} />
                </ContentColumn>
                <ContentColumn>
                  <DarkWideButton onClick={addNewToCart}>Kjøp</DarkWideButton>
                </ContentColumn>
              </Row>
            </Content>
          </Column>
        ) : null}
      </Row>
      <CalloutButton
        type="button"
        onClick={(e) => {
          scrollTo(document.getElementById('buy-row'), 250);
        }}
      >
        Kjøp<CalloutButtonIcon src={arrowIcon} />
      </CalloutButton>
    </Wrapper>
  );
}

export default withRouter(AddToCart);

AddToCart.propTypes = {
  carPartId: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ]),
  price: PropTypes.number,
  shipping: PropTypes.number,
  newPrice: PropTypes.number,
  addNewToCart: PropTypes.func,
  addUsedToCart: PropTypes.func,
  isInCart: PropTypes.bool
};

export const CartButton = ({ part, isInCart, onClick, newItem, fullWidth }) => <Column
  fullWidth={fullWidth}
>
  <Content>
    <Row>
      <ContentColumn>
        {part.price && <Price amount={part.price} dark={newItem} shipping={part.shipping} /> || ''}
      </ContentColumn>
      <ContentColumn>
        {isInCart && (
          <Link to="/handlekurv/">
            <HollowButton>Se i handlekurv</HollowButton>
          </Link>
        )}

        {!isInCart && !newItem && <WideButton onClick={onClick}>Kjøp</WideButton> || ''}
        {!isInCart && newItem && <DarkWideButton onClick={onClick}>Kjøp nydel</DarkWideButton> || ''}

        <SendRequest
          to={`/foresporsel/?id=${part.id}&lagernummer=${part.stockNumber}&delenavn=${part.name}`}
        >
          Send forespørsel »
        </SendRequest>
      </ContentColumn>
    </Row>
  </Content>
</Column>;

export const RequestButton = withRouter(({ history, part, fullWidth }) => <Column
  fullWidth={fullWidth}
>
  <Content>
    <Row>
      <ContentColumn>
      </ContentColumn>
      <ContentColumn>
        <DarkWideButton
          onClick={(e) => {
            e.preventDefault();

            history.push(`/foresporsel/?id=${part.id}&lagernummer=${part.stockNumber}&delenavn=${part.name}`);
          }}
        >
          Send forespørsel »
        </DarkWideButton>
      </ContentColumn>
    </Row>
  </Content>
</Column>);
